import { getSelectorRoot } from 'utils/selectors';

const getLoadings = getSelectorRoot('loadings');

export const getRegionDataLoading = getLoadings('regionDataLoading');
